import React from 'react';
import i18n from '@i18next/i18n';
import styles from '@com-pc/status-bar.less';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IReactionDisposer, reaction } from 'mobx';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';

interface IProps {
    handlePageInfoClick: () => void;
}

interface IState {
    slideCount: number;
    currentIndex: number;
}

export class StatusPageInfo extends React.Component<IProps, IState> {
    private slideIndexAction: IReactionDisposer;
    constructor(props) {
        super(props);
        this.state = {
            slideCount: SlideDataServices.States.SlideCountState()?.slideCount
                ?? this.getSelectionService().slides.length,
            currentIndex: this.getSelectionService().currentSlideIndex,
        };

        SlideDataServices.States.SlideCountState.promise().then((slideCounter) => {
            reaction(
                () => slideCounter.slideCount,
                slideCount => this.setState({ slideCount }),
                { fireImmediately: true },
            );
        });
    }

    public componentDidMount() {
        this.slideIndexAction = reaction(
            () => this.getSelectionService()?.currentSlideIndex,
            () => this.forceUpdate(),
        );
    }

    public render() {
        let pageInfo = '';
        const index = this.getSelectionService().currentSlideIndex + 1;
        if (this.getSelectionService().currentSlideIndex === -1) {
            pageInfo = i18n.t('共 {0} 页', { 0: this.state.slideCount });
        } else {
            pageInfo = i18n.t('第 {0} 页/共 {1} 页', { 0: index, 1: this.state.slideCount });
        }

        const isMasterShow = this.getMasterLayoutService()?.isMasterEditType;

        return (
            <p onClick={this.props.handlePageInfoClick} className={styles.pageInfos}>
                {!isMasterShow && pageInfo}
            </p>);
    }

    public componentWillUnmount() {
        this.slideIndexAction?.();
    }

    private getSelectionService = () => (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
        .viewableServiceLayer?.selectionService;

    private getMasterLayoutService = () => (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
        .editableServiceLayer?.masterLayoutEditService;
}
